import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateTable from "../../CreateTable";
import {
  startChangePasswordAction,
  userDisableAction,
  userEditAction,
  userEnableAction,
  userListAction
} from "./../../../modules/userManagement/action";

class AllUserListTable extends Component {
  state = {
    headerRows: {
      updatedAt: "Date",
      updatedBy: "Updated By",
      name: "Name",
      username: "Email/Username",
      displayedRoleName: "Type",
      enabled: "Status",
      subscriptionPlan: "Subscription Plan"
    },
    order: "desc",
    orderBy: "id"
  };

  deleteRow = id => {
    //this.props.userDeleteAction(id);
  };

  editRow = id => {
    const { usersList } = this.props;
    const requiredData = usersList.find(user => user.id === id);
    this.props.userEditAction(requiredData);
  };

  changePassword = id => {
    const { usersList } = this.props;
    const requiredData = usersList.find(user => user.id === id);
    this.props.startChangePasswordAction(requiredData);
  };

  toggle = (id, isChecked) => {
    console.log(`${id} and ${isChecked}`);
    isChecked
      ? this.props.userDisableAction(id)
      : this.props.userEnableAction(id);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { headerRows, order, orderBy } = this.state;
    const { usersList, location, changePasswordLocation } = this.props;
    return (
      <div>
        <CreateTable
          order={order}
          orderBy={orderBy}
          headerRows={headerRows}
          rowData={usersList.filter(user => user.subscriptionPlan)}
          onRequestSort={this.handleRequestSort}
          isMenuRequired={true}
          //delete={this.deleteRow}
          edit={this.editRow}
          toggle={this.toggle}
          location={location}
          changePasswordLocation={changePasswordLocation}
          changePassword={this.changePassword}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    usersList: state.userManagementReducer.usersList
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      userListAction,
      userEditAction,
      startChangePasswordAction,
      userDisableAction,
      userEnableAction
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUserListTable);



// WEBPACK FOOTER //
// ./src/components/private/UserManagement/AllUserListTable.js